import React, { useEffect, useContext, useRef } from 'react'
//@ts-ignore
import { NavLink, useRouteMatch } from 'react-router-dom'
import { SideNavigationItemProps } from './SideNavigation.types'
import Icon from '../Icon/Icon'

import { SideNavigationContext } from './SideNavigation'
// @ts-ignore
// import { useMatch } from 'react-router'

const SideNavigationItem = React.forwardRef<HTMLDivElement, SideNavigationItemProps>((props, ref) => {
    const { onClick, icon, name, exact = false, nameKey, path, render } = props
    const { isCollapsed, isTransitioning, onSelect, selectedNameKey } = useContext(SideNavigationContext)
    const display = isCollapsed || isTransitioning ? (icon ? null : nameKey) : name
    const isMatch = path ? useRouteMatch(path) : false
    const isSelected = isMatch || selectedNameKey === nameKey
    const internalRef = useRef(null)
    const handleClick = () => {
        onSelect(nameKey)
        if (onClick) {
            onClick(nameKey)
        }
    }

    useEffect(() => {
        if (internalRef?.current) {
            internalRef.current.scrollIntoView()
        }
    }, [isSelected, internalRef.current])

    const view = render ? (
        render()
    ) : (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }} ref={internalRef}>
            <span>
                {icon && isCollapsed ? <Icon type={icon} /> : ''}
                {display}
            </span>
            {isSelected && !isCollapsed ? <Icon type={'chevron-right'} /> : null}
        </div>
    )
    console.log('NAV PATH', path)
    if (!path) {
        return (
            <div ref={ref} className={`r-side-navigation-item ${isSelected ? 'selected' : ''}`} onClick={handleClick}>
                {view}
            </div>
        )
    }

    const pathData = getPath(path)

    if (pathData) {
        return (
            <div ref={ref} className={'r-side-navigation-item-container'}>
                <NavLink
                    onClick={handleClick}
                    to={pathData.path}
                    className={({ isActive }) => 'r-side-navigation-item' + (isActive ? ' selected' : '')}
                >
                    {view}
                </NavLink>
            </div>
        )
    }

    return (
        <div
            ref={ref}
            className={`r-side-navigation-item ${selectedNameKey === nameKey ? 'selected' : ''}`}
            // onClick={() => {
            //     window.location.assign(pathData.path)
            // }}
        >
            {view}
        </div>
    )
})

export default SideNavigationItem

function getPath(path: string) {
    if (path.startsWith('http')) {
        const { origin, pathname } = new URL(path)
        const isSameOrigin = window.location.origin === origin
        return {
            path: isSameOrigin ? pathname : path,
            isSameOrigin,
        }
    }
    return { path: path, isSameOrigin: true }
}
